import { render, staticRenderFns } from "./page-not-found.vue?vue&type=template&id=430aed04&scoped=true&"
var script = {}
import style0 from "./page-not-found.vue?vue&type=style&index=0&id=430aed04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "430aed04",
  null
  
)

export default component.exports